const CJK_CHARACTER_PATTERN = /[　-〿㐀-鿿＀-￯]/;

const isCjkBoundary = (previousWord: string, nextWord: string) =>
  CJK_CHARACTER_PATTERN.test(previousWord.slice(-1)) &&
  CJK_CHARACTER_PATTERN.test(nextWord.charAt(0));

export const joinWords = (words: (string | null | undefined)[]) =>
  words
    .filter((word): word is string => !!word)
    .reduce((sentence, word) => {
      if (!sentence) return word;
      return isCjkBoundary(sentence, word)
        ? `${sentence}${word}`
        : `${sentence} ${word}`;
    }, "");
